export { preventEmptyBlockCollapsing } from "./preventEmptyBlockCollapsing.mjs";
export { preventWhitespaceCollapsing } from "./preventWhitepaceCollapsing.mjs";
export { provideIsHeaderToTableCells } from "./provideIsHeaderToTableCells.mjs";